import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const PortalLayout = () => {
  return (
    <div className="bg-[#fdffff]">
      <Header />
      <div className="container py-5 max-w-full lg:max-w-[95vw]">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default PortalLayout;
